import { RecordTypeInfo } from './DescribeTypes'

export const reportRecordTypesFieldsMapSF = {
  direction: 'in',
  Id: 'id',
  Name: 'name',
  CreatedDate: 'createdDate',
  LastModifiedDate: 'lastModifiedDate',
  FGM_Base__Contact_Organization__c: 'organization',
  FGM_Base__Request_Number__c: 'requestNumber',
  FGM_Base__Status__c: 'status',
  FGM_Base__Due_Date__c: 'dueDate',
  Funding_stream_name__c: 'fundingStream',
  Project_progress__c: 'projectProgress',
  Is_project_finished__c: 'isProjectFinished',
  Challenges__c: 'challenges',
  Community_impact_description__c: 'communityImpact',
  Lessons_learned__c: 'lessonsLearned',
  Testimonial__c: 'testimonial',
  Type__c: 'type'
}

export interface ReportRecordTypes {
  id: string
  name: string
  createdDate: string
  lastModifiedDate: string
  organization: string | null
  requestNumber: string | null
  status: string | null
  dueDate: string | null
  fundingStream: string | null
  projectProgress: number | null
  isProjectFinished: string | null
  challenges: string | null
  communityImpact: string | null
  lessonsLearned: string | null
  testimonial: string | null
  type: string | null
}

export interface ReportRecordTypesMap {
  [key: string]: RecordTypeInfo
}
